

export const styleCalendar={
    pt:23,
    pr:4,
    borderColor:"secondary.main"
}

export const styleModalCalendar={
    pt:0,
}

export const styleModalCalendarButton={
    pt:10,
    
}
export const styleModalCalendarButtonCancel={
    pt:10,
    pr:55,
    
}